import { render } from "./MapsPage.vue?vue&type=template&id=02b4ea24"
import script from "./MapsPage.vue?vue&type=script&lang=js"
export * from "./MapsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__